<e-dialog [open]="target() !== null" (openChange)="onOpenChange($event)" [title]="title()" size="md">
  <ng-template>
    <div class="group-edit-form">
      <label class="group-edit-label" for="group-name">{{ text().nameLabel }}</label>
      <input
        id="group-name"
        ngDefaultControl
        name="groupName"
        type="text"
        class="group-edit-input"
        [ngModel]="name()"
        (ngModelChange)="name.set($event)"
      />

      <label class="group-edit-label">{{ text().parentLabel }}</label>
      <ng-select
        class="group-edit-parent"
        appendTo="body"
        [items]="parentOptions()"
        bindValue="value"
        bindLabel="label"
        [clearable]="false"
        [ngModel]="parentGroupId()"
        (ngModelChange)="parentGroupId.set($event)"
      ></ng-select>

      <label class="group-edit-label">{{ text().iconLabel }}</label>
      <hd-icon-picker [(value)]="icon"></hd-icon-picker>

      <label class="group-edit-checkbox">
        <input
          type="checkbox"
          ngDefaultControl
          name="isDefaultSelection"
          [ngModel]="isDefaultSelection()"
          (ngModelChange)="isDefaultSelection.set($event)"
        />
        <span>{{ text().defaultSelectionLabel }}</span>
      </label>

      <div class="group-edit-actions">
        <button eBtn color="highlight" (click)="onOpenChange(false)">{{ text().cancel }}</button>
        <button eBtn color="primary-75" [disabled]="!canSave" (click)="save()">{{ text().save }}</button>
      </div>
    </div>
  </ng-template>
</e-dialog>
